import { getCsrfToken } from 'helpers/csrf';

export const CLEAR_PASS = 'CLEAR_PASS';
export const GET_CARD_BEGIN = 'GET_CARD_BEGIN';
export const GET_CARD_SUCCESS = 'GET_CARD_SUCCESS';
export const GET_CARD_FAILURE = 'GET_CARD_FAILURE';
export const CHARGE_CARD_BEGIN = 'CHARGE_CARD_BEGIN';
export const CHARGE_CARD_SUCCESS = 'CHARGE_CARD_SUCCESS';
export const CHARGE_CARD_FAILURE = 'CHARGE_CARD_FAILURE';

export const clearPass = () => ({
  type: CLEAR_PASS,
});

const fetchGetCardSuccess = (data) => ({
  type: GET_CARD_SUCCESS,
  payload: data,
});

const fetchGetCardBegin = () => ({
  type: GET_CARD_BEGIN,
});

const fetchGetCardFailure = (error) => ({
  type: GET_CARD_FAILURE,
  error: error.message,
});

export const getCard = ({ cardNumber, cardOwnership }) => (dispatch) => {
  if (!cardNumber) {
    cardNumber = 'init';
  }
  dispatch(fetchGetCardBegin());
  return fetch(`/api/cards/${cardOwnership}/${cardNumber}`, {
    credentials: 'same-origin'
  })
    .then(response => handleErrors(response))
    .then(data => dispatch(fetchGetCardSuccess(data)))
    .catch(err => {
      if (cardNumber === 'init') {
        return dispatch(fetchGetCardFailure(err));
      }
      if (!cardNumber) {
        return dispatch(fetchGetCardFailure(err));
      }
      return dispatch(fetchGetCardFailure(err));
    });
}

const fetchChargeCardSuccess = (data) => ({
  type: CHARGE_CARD_SUCCESS,
  payload: data,
});

const fetchChargeCardBegin = () => ({
  type: CHARGE_CARD_BEGIN,
});

const fetchChargeCardFailure = (error) => ({
  type: CHARGE_CARD_FAILURE,
  error
});

export const chargeCard = ({ cardNumber, cardType, amount }) => async (dispatch) => {
  dispatch(fetchChargeCardBegin());
  const token = await getCsrfToken();
  return fetch(`/api/cards/${cardNumber}/charge`, {
    method: 'POST',
    body: JSON.stringify({ amount }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'x-csrf-token': token,
    }})
  .then(response => handleErrors(response))
  .then(data => dispatch(fetchChargeCardSuccess(data)))
  .catch(err => dispatch(fetchChargeCardFailure(err.message)));
}


function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(errorResponse => {
      let msg;
      if (errorResponse.extraParameters && Array.isArray(errorResponse.extraParameters.json)) {
        msg = errorResponse.extraParameters.json[0];
      }
      if (response.status === 404) {
        throw new Error(msg || errorResponse.detail || 'Deze pas werd niet gevonden.');
      } else if (response.status === 403) {
        throw new Error(msg || 'U heeft geen toegang.');
      } else {
        throw new Error(msg || 'Er is een fout opgetreden.');
      }
    }).catch(err => {
      throw err;
    });
  }
  return response.json();
}
